(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(30441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _codebuild_output_src3226388324_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3226388324_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3226388324_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var services_ApiCall__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62669);




var useGetVersion = function() {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
        "GetBackendVersion"
    ], (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3226388324_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, formData, res, ref1;
        return _codebuild_output_src3226388324_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    formData = new FormData();
                    _ctx.next = 4;
                    return services_ApiCall__WEBPACK_IMPORTED_MODULE_2__/* ["default"].api.post */ .Z.api.post("/ldx_version/", formData);
                case 4:
                    res = _ctx.sent;
                    ;
                    return _ctx.abrupt("return", (ref1 = (ref = res.data) === null || ref === void 0 ? void 0 : ref.result) !== null && ref1 !== void 0 ? ref1 : "");
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        staleTime: 5000 * 60
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetVersion);


/***/ }),

/***/ 30441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var views_Login_Login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98778);

/* harmony default export */ __webpack_exports__["default"] = (views_Login_Login__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 98778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Login_Login; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 1 modules
var notification = __webpack_require__(13448);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/card/index.js + 3 modules
var card = __webpack_require__(59652);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 5 modules
var formik_esm = __webpack_require__(43472);
// EXTERNAL MODULE: ./src/services/ApiCall.ts + 4 modules
var ApiCall = __webpack_require__(62669);
// EXTERNAL MODULE: ./src/data/Version/useGetVersion.ts
var useGetVersion = __webpack_require__(6728);
// EXTERNAL MODULE: ./src/components/fields.ts + 3 modules
var fields = __webpack_require__(6733);
// EXTERNAL MODULE: ./src/components/Typography/Text.tsx
var Text = __webpack_require__(30805);
// EXTERNAL MODULE: ./src/helpers/parseJWT.ts
var parseJWT = __webpack_require__(64220);
// EXTERNAL MODULE: ./src/helpers/useAuth.tsx
var useAuth = __webpack_require__(58975);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 16 modules
var es_form = __webpack_require__(28926);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 5 modules
var input = __webpack_require__(11486);
;// CONCATENATED MODULE: ./src/views/Login/TwoFactorAuthLogin.tsx








var TwoFactorAuthLogin = function(param) {
    var password = param.password, userId = param.userId;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isSubmitting = ref[0], setSubmitting = ref[1];
    var handleSubmitCode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var ref, formData, res, _data, access_token, refresh_token, name, user_type;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSubmitting(true);
                        _ctx.prev = 1;
                        ;
                        formData = new FormData();
                        formData.append("password", password);
                        formData.append("user_id", userId);
                        formData.append("totp", values.code);
                        _ctx.next = 9;
                        return ApiCall/* default.api.post */.Z.api.post("/totp_auth", formData);
                    case 9:
                        res = _ctx.sent;
                        _data = res.data, access_token = _data.access_token, refresh_token = _data.refresh_token, name = _data.name, user_type = _data.user_type;
                        localStorage.setItem("token-ldx", access_token);
                        localStorage.setItem("key-pin", res.headers.kid);
                        localStorage.setItem("refresh-token", refresh_token);
                        localStorage.setItem("name", name);
                        localStorage.setItem("current_user_type", user_type);
                        if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.prevPage) {
                            router.replace(router.query.prevPage);
                        } else {
                            router.replace("/home");
                        }
                        _ctx.next = 22;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](1);
                        notification/* default.error */.Z.error({
                            message: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message
                        });
                    case 22:
                        _ctx.prev = 22;
                        setSubmitting(false);
                        return _ctx.finish(22);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    19,
                    22,
                    25
                ]
            ]);
        }));
        return function handleSubmitCode(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
        justify: "center",
        align: "middle",
        className: "h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
            sm: 12,
            xs: 24,
            md: 9,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                title: t("two_factor_authentication"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                    layout: "vertical",
                    colon: false,
                    onFinish: handleSubmitCode,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                            name: "code",
                            label: t("common:authentication_code"),
                            extra: t("common:authentication_two_factor_help"),
                            rules: [
                                {
                                    required: true
                                }, 
                            ],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                type: "number",
                                placeholder: "e.g. 123456"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                type: "primary",
                                block: true,
                                loading: isSubmitting,
                                htmlType: "submit",
                                className: "w-1/2",
                                children: t("common:login")
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Login_TwoFactorAuthLogin = (TwoFactorAuthLogin);

// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__(4147);
;// CONCATENATED MODULE: ./src/views/Login/Login.tsx

















function Login() {
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)([
        "common"
    ]).t;
    var ref = (0,useGetVersion/* default */.Z)(), backendVersion = ref.data;
    var postLogin = (0,es.useMutation)(function(data) {
        return ApiCall/* default.login */.Z.login(data);
    }, {
        onSuccess: function(param, param1) {
            var data = param.data, password = param1.password;
            if (data.user_id) {
                setLoginData({
                    password: password,
                    user_id: data === null || data === void 0 ? void 0 : data.user_id
                });
            }
        }
    });
    var ref1 = (0,react.useState)({
        password: "",
        user_id: ""
    }), loginData = ref1[0], setLoginData = ref1[1];
    (0,react.useEffect)(function() {
        if (router.isReady) {
            var refreshToken = localStorage.getItem("refresh-token");
            var parsedJwt = (0,parseJWT/* default */.Z)(refreshToken);
            var keyPin = localStorage.getItem("key-pin");
            if (parsedJwt && keyPin) {
                var ref;
                if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.prevPage) {
                    router_default().replace(router.query.prevPage);
                } else {
                    router_default().replace("/home");
                }
            }
        }
    }, [
        router.isReady
    ]);
    // This useEffect is temporary, and soon will be deleted after
    // the issue in dev7 is fixed
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.error) {
            notification/* default.error */.Z.error({
                message: t("common:".concat(router.query.error))
            });
        }
    }, []);
    if (loginData === null || loginData === void 0 ? void 0 : loginData.user_id) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_TwoFactorAuthLogin, {
            password: loginData.password,
            userId: loginData.user_id
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            username: "",
            password: "",
            db: "LDX_NEW" || 0
        },
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, param) {
                var setSubmitting, ref, res, ref1, ref2, _data, access_token, refresh_token, name, user_type, username;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setSubmitting = param.setSubmitting;
                            _ctx.prev = 1;
                            ;
                            _ctx.next = 5;
                            return postLogin.mutateAsync(values);
                        case 5:
                            res = _ctx.sent;
                            if (!res.data.error) {
                                _ctx.next = 10;
                                break;
                            }
                            ;
                            notification/* default.error */.Z.error({
                                message: (ref1 = res.data.error) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message
                            });
                            return _ctx.abrupt("return");
                        case 10:
                            if (!res.data.user_id) {
                                _ctx.next = 12;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 12:
                            notification/* default.success */.Z.success({
                                message: t("common:login_successfully")
                            });
                            _data = res.data, access_token = _data.access_token, refresh_token = _data.refresh_token, name = _data.name, user_type = _data.user_type, username = _data.username;
                            localStorage.setItem("token-ldx", access_token);
                            localStorage.setItem("key-pin", res.headers.kid);
                            localStorage.setItem("refresh-token", refresh_token);
                            localStorage.setItem("name", name);
                            localStorage.setItem("username", username);
                            localStorage.setItem("current_user_type", user_type);
                            (0,useAuth/* triggerAuthChange */.j)();
                            if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.prevPage) {
                                router_default().replace(router.query.prevPage);
                            } else {
                                router_default().replace("/home");
                            }
                            _ctx.next = 27;
                            break;
                        case 24:
                            _ctx.prev = 24;
                            _ctx.t0 = _ctx["catch"](1);
                            notification/* default.error */.Z.error({
                                message: _ctx.t0.message
                            });
                        case 27:
                            _ctx.prev = 27;
                            setSubmitting(false);
                            return _ctx.finish(27);
                        case 30:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        24,
                        27,
                        30
                    ]
                ]);
            }));
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(formikProps) {
            var isSubmitting = formikProps.isSubmitting;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                className: "h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        justify: "center",
                        align: "middle",
                        style: {
                            minHeight: "calc(100vh - 50px)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            sm: 12,
                            xs: 24,
                            md: 9,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* FInput */.hC, {
                                        name: "username",
                                        title: t("common:user_id")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "my-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* FInput */.hC, {
                                            type: "password",
                                            name: "password",
                                            title: t("common:password")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                            type: "primary",
                                            block: true,
                                            loading: isSubmitting,
                                            htmlType: "submit",
                                            className: "w-1/2",
                                            children: t("common:login")
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        style: {
                            padding: 16,
                            borderTop: "1px solid #003288"
                        },
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: "".concat(t("version_be"), ": ").concat(backendVersion || "-")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {
                                    type: "vertical",
                                    className: "h-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: "".concat(t("version_fe"), ": v").concat(package_0/* version */.i8)
                                })
                            ]
                        })
                    })
                ]
            });
        }
    });
}
/* harmony default export */ var Login_Login = (Login);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [40125,59652,49774,92888,40179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);